import axios from "../util/axiosconfig";

export const ForgotPasswordApi = async (userEmail: string) => {
  const response = await axios.post(
    "auth/forgot-password",
    {
      userEmail,
    }
  );
  return response.data;
};
